import * as React from 'react';
import styles from './Home.module.css';

interface HomeProps {
  lang: 'en' | 'it';
}

/**
 * Home Component
 * 
 * Displays the landing page/hero section with the user's name and subtitle.
 * It takes up the full viewport height.
 */
const Home: React.FC<HomeProps> = ({ lang }) => {
  return (
    <div className={styles.pageContainer}>
      {/* Hero Section - Full height container */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Lorenzo Quadrelli</h1>
          <p className={styles.heroSubtitle}>
            {lang === 'en' ? 'Portfolio & Curriculum' : 'Portfolio e Curriculum'}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;